export class ImageConfiguration {
  ImageId: number;
  X: number;
  Y: number;
  Height: number;
  Width: number;
  ImageType: number;
}

export enum ImageConfigurationType {
  HomePage = 1,
  DetailView = 2,
  MobileView = 3
}
